/**
 * completion-status-icon.js
 */

import React from 'react';
import { Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import Icon from 'components/icon';
import StatusBadge from '../status-badge';


export default function CompletionStatusIcon(props) {
  const {
    params,
    showBadge,
    showTooltip,
    to,
  } = props;

  const baseContent = <Icon type={params.id} className={`icon-${params.id}`} />;

  const linkContent = to
    ? <Link to={to} style={{ display: 'flex' }}>
      {baseContent}
    </Link>
    : baseContent;

  const badgeContent = showBadge && params.numIncomplete > 0
    ? <StatusBadge badgeContent={params.numIncomplete}>
      {linkContent}
    </StatusBadge>
    : linkContent;

  const tooltipContent = showTooltip
    ? <Tooltip
      arrow
      placement='top'
      title={params.label}
      style={{ position: 'relative', display: 'flex' }}
    >
      <span>
        {badgeContent}
      </span>
    </Tooltip>
    : badgeContent;
  

  return tooltipContent;
}